import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { SalesProducts } from './sales-products.model';

export const salesProductsApiActions = createActionGroup({
  source: 'Sales products/API',
  events: {
    'Load sales products': emptyProps(),
    'Load sales products success': props<{ salesProducts: SalesProducts }>(),
    'Load sales products failure': props<{ error: any }>(),
  },
});
